import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ fullWidth: boolean }>()((theme) => ({
  textFieldInput: {
    textAlign: 'center',
  },
  menuContainer: {
    width: '250px',
    height: '300px !important',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      height:
        'calc(var(--vv-height, 100dvh) - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)) !important',
      display: 'flex',
      flexDirection: 'column',

      '& .MuiList-root.MuiMenu-list': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
  timeSetterHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: '100%',
    flexShrink: 0,
  },
  timeSetterWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '210px',

    [theme.breakpoints.down('md')]: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '252px',
      paddingBottom: theme.spacing(3),
      boxSizing: 'border-box',
    },
  },
  textField: {
    marginTop: theme.spacing(1),
  },
}));
